// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/__root'
import { Route as IndexRouteImport } from './app/index'
import { Route as SplatRouteImport } from './app/$'
import { Route as PayloadRouteImport } from './app/_payload'
import { Route as AboutRouteImport } from './app/about'
import { Route as AppRouteImport } from './app/app'
import { Route as AppStoreRedirectRouteImport } from './app/app-store-redirect'
import { Route as BusinessRouteImport } from './app/business'
import { Route as CardsRouteImport } from './app/cards'
import { Route as CareersRouteImport } from './app/careers'
import { Route as CompareRouteImport } from './app/compare'
import { Route as GetTheAppRouteImport } from './app/get-the-app'
import { Route as HealthInsuranceRouteImport } from './app/health-insurance'
import { Route as HelpRouteImport } from './app/help'
import { Route as InvestRouteImport } from './app/invest'
import { Route as NewsRouteImport } from './app/news'
import { Route as PartnershipsRouteImport } from './app/partnerships'
import { Route as PayrollRouteImport } from './app/payroll'
import { Route as PerksRouteImport } from './app/perks'
import { Route as PricingRouteImport } from './app/pricing'
import { Route as PrivacyPolicyRouteImport } from './app/privacy-policy'
import { Route as RewardsRouteImport } from './app/rewards'
import { Route as SendMoneyHomeRouteImport } from './app/send-money-home'
import { Route as StablecoinRouteImport } from './app/stablecoin'
import { Route as ZakatCalculatorRouteImport } from './app/zakat-calculator'
import { Route as LocaleIndexRouteImport } from './app/$locale.index'
import { Route as LocaleSplatRouteImport } from './app/$locale.$'
import { Route as ArIndexRouteImport } from './app/ar.index'
import { Route as ArBusinessRouteImport } from './app/ar.business'
import { Route as ArPricingRouteImport } from './app/ar.pricing'
import { Route as ArticleSlugRouteImport } from './app/article.$slug'
import { Route as BangladeshSlugRouteImport } from './app/bangladesh.$slug'
import { Route as BusinessDemoRouteImport } from './app/business_.demo'
import { Route as BusinessHowItWorksRouteImport } from './app/business_.how-it-works'
import { Route as BusinessWaitlistRouteImport } from './app/business_.waitlist'
import { Route as CalculatorPairRouteImport } from './app/calculator.$pair'
import { Route as CardsMarketersRouteImport } from './app/cards_.marketers'
import { Route as HelpSlugRouteImport } from './app/help_.$slug'
import { Route as NewsSlugRouteImport } from './app/news_.$slug'
import { Route as PakistanSlugRouteImport } from './app/pakistan.$slug'
import { Route as ProductsBusinessSuccessRouteImport } from './app/products.business-success'
import { Route as SyriaSlugRouteImport } from './app/syria.$slug'
import { Route as TermsIndexRouteImport } from './app/terms.index'
import { Route as TermsSplatRouteImport } from './app/terms.$'
import { Route as TermsCookieRouteImport } from './app/terms.cookie'
import { Route as PayloadAdminIndexRouteImport } from './app/_payload/admin.index'
import { Route as PayloadAdminSplatRouteImport } from './app/_payload/admin.$'
import { Route as PreviewArticlesIdRouteImport } from './app/preview.articles.$id'
import { Route as PreviewLegalPagesIdRouteImport } from './app/preview.legal-pages.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const PayloadRoute = PayloadRouteImport.update({
            id: '/_payload',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./app/_payload.lazy').then((d) => d.Route))
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const AppStoreRedirectRoute = AppStoreRedirectRouteImport.update({
            id: '/app-store-redirect',path: '/app-store-redirect',getParentRoute: () => rootRouteImport
          })
const BusinessRoute = BusinessRouteImport.update({
            id: '/business',path: '/business',getParentRoute: () => rootRouteImport
          })
const CardsRoute = CardsRouteImport.update({
            id: '/cards',path: '/cards',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const CompareRoute = CompareRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => rootRouteImport
          })
const GetTheAppRoute = GetTheAppRouteImport.update({
            id: '/get-the-app',path: '/get-the-app',getParentRoute: () => rootRouteImport
          })
const HealthInsuranceRoute = HealthInsuranceRouteImport.update({
            id: '/health-insurance',path: '/health-insurance',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const InvestRoute = InvestRouteImport.update({
            id: '/invest',path: '/invest',getParentRoute: () => rootRouteImport
          })
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          })
const PartnershipsRoute = PartnershipsRouteImport.update({
            id: '/partnerships',path: '/partnerships',getParentRoute: () => rootRouteImport
          })
const PayrollRoute = PayrollRouteImport.update({
            id: '/payroll',path: '/payroll',getParentRoute: () => rootRouteImport
          })
const PerksRoute = PerksRouteImport.update({
            id: '/perks',path: '/perks',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const RewardsRoute = RewardsRouteImport.update({
            id: '/rewards',path: '/rewards',getParentRoute: () => rootRouteImport
          })
const SendMoneyHomeRoute = SendMoneyHomeRouteImport.update({
            id: '/send-money-home',path: '/send-money-home',getParentRoute: () => rootRouteImport
          })
const StablecoinRoute = StablecoinRouteImport.update({
            id: '/stablecoin',path: '/stablecoin',getParentRoute: () => rootRouteImport
          })
const ZakatCalculatorRoute = ZakatCalculatorRouteImport.update({
            id: '/zakat-calculator',path: '/zakat-calculator',getParentRoute: () => rootRouteImport
          })
const LocaleIndexRoute = LocaleIndexRouteImport.update({
            id: '/$locale/',path: '/$locale/',getParentRoute: () => rootRouteImport
          })
const LocaleSplatRoute = LocaleSplatRouteImport.update({
            id: '/$locale/$',path: '/$locale/$',getParentRoute: () => rootRouteImport
          })
const ArIndexRoute = ArIndexRouteImport.update({
            id: '/ar/',path: '/ar/',getParentRoute: () => rootRouteImport
          })
const ArBusinessRoute = ArBusinessRouteImport.update({
            id: '/ar/business',path: '/ar/business',getParentRoute: () => rootRouteImport
          })
const ArPricingRoute = ArPricingRouteImport.update({
            id: '/ar/pricing',path: '/ar/pricing',getParentRoute: () => rootRouteImport
          })
const ArticleSlugRoute = ArticleSlugRouteImport.update({
            id: '/article/$slug',path: '/article/$slug',getParentRoute: () => rootRouteImport
          })
const BangladeshSlugRoute = BangladeshSlugRouteImport.update({
            id: '/bangladesh/$slug',path: '/bangladesh/$slug',getParentRoute: () => rootRouteImport
          })
const BusinessDemoRoute = BusinessDemoRouteImport.update({
            id: '/business_/demo',path: '/business/demo',getParentRoute: () => rootRouteImport
          })
const BusinessHowItWorksRoute = BusinessHowItWorksRouteImport.update({
            id: '/business_/how-it-works',path: '/business/how-it-works',getParentRoute: () => rootRouteImport
          })
const BusinessWaitlistRoute = BusinessWaitlistRouteImport.update({
            id: '/business_/waitlist',path: '/business/waitlist',getParentRoute: () => rootRouteImport
          })
const CalculatorPairRoute = CalculatorPairRouteImport.update({
            id: '/calculator/$pair',path: '/calculator/$pair',getParentRoute: () => rootRouteImport
          })
const CardsMarketersRoute = CardsMarketersRouteImport.update({
            id: '/cards_/marketers',path: '/cards/marketers',getParentRoute: () => rootRouteImport
          })
const HelpSlugRoute = HelpSlugRouteImport.update({
            id: '/help_/$slug',path: '/help/$slug',getParentRoute: () => rootRouteImport
          })
const NewsSlugRoute = NewsSlugRouteImport.update({
            id: '/news_/$slug',path: '/news/$slug',getParentRoute: () => rootRouteImport
          })
const PakistanSlugRoute = PakistanSlugRouteImport.update({
            id: '/pakistan/$slug',path: '/pakistan/$slug',getParentRoute: () => rootRouteImport
          })
const ProductsBusinessSuccessRoute = ProductsBusinessSuccessRouteImport.update({
            id: '/products/business-success',path: '/products/business-success',getParentRoute: () => rootRouteImport
          })
const SyriaSlugRoute = SyriaSlugRouteImport.update({
            id: '/syria/$slug',path: '/syria/$slug',getParentRoute: () => rootRouteImport
          })
const TermsIndexRoute = TermsIndexRouteImport.update({
            id: '/terms/',path: '/terms/',getParentRoute: () => rootRouteImport
          })
const TermsSplatRoute = TermsSplatRouteImport.update({
            id: '/terms/$',path: '/terms/$',getParentRoute: () => rootRouteImport
          })
const TermsCookieRoute = TermsCookieRouteImport.update({
            id: '/terms/cookie',path: '/terms/cookie',getParentRoute: () => rootRouteImport
          })
const PayloadAdminIndexRoute = PayloadAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => PayloadRoute
          }).lazy(() => import('./app/_payload/admin.index.lazy').then((d) => d.Route))
const PayloadAdminSplatRoute = PayloadAdminSplatRouteImport.update({
            id: '/admin/$',path: '/admin/$',getParentRoute: () => PayloadRoute
          }).lazy(() => import('./app/_payload/admin.$.lazy').then((d) => d.Route))
const PreviewArticlesIdRoute = PreviewArticlesIdRouteImport.update({
            id: '/preview/articles/$id',path: '/preview/articles/$id',getParentRoute: () => rootRouteImport
          })
const PreviewLegalPagesIdRoute = PreviewLegalPagesIdRouteImport.update({
            id: '/preview/legal-pages/$id',path: '/preview/legal-pages/$id',getParentRoute: () => rootRouteImport
          })





const PayloadRouteChildren = {
  PayloadAdminSplatRoute: PayloadAdminSplatRoute,PayloadAdminIndexRoute: PayloadAdminIndexRoute
}

const PayloadRouteWithChildren = PayloadRoute._addFileChildren(PayloadRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,PayloadRoute: PayloadRouteWithChildren,AboutRoute: AboutRoute,AppRoute: AppRoute,AppStoreRedirectRoute: AppStoreRedirectRoute,BusinessRoute: BusinessRoute,CardsRoute: CardsRoute,CareersRoute: CareersRoute,CompareRoute: CompareRoute,GetTheAppRoute: GetTheAppRoute,HealthInsuranceRoute: HealthInsuranceRoute,HelpRoute: HelpRoute,InvestRoute: InvestRoute,NewsRoute: NewsRoute,PartnershipsRoute: PartnershipsRoute,PayrollRoute: PayrollRoute,PerksRoute: PerksRoute,PricingRoute: PricingRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RewardsRoute: RewardsRoute,SendMoneyHomeRoute: SendMoneyHomeRoute,StablecoinRoute: StablecoinRoute,ZakatCalculatorRoute: ZakatCalculatorRoute,LocaleSplatRoute: LocaleSplatRoute,ArBusinessRoute: ArBusinessRoute,ArPricingRoute: ArPricingRoute,ArticleSlugRoute: ArticleSlugRoute,BangladeshSlugRoute: BangladeshSlugRoute,BusinessDemoRoute: BusinessDemoRoute,BusinessHowItWorksRoute: BusinessHowItWorksRoute,BusinessWaitlistRoute: BusinessWaitlistRoute,CalculatorPairRoute: CalculatorPairRoute,CardsMarketersRoute: CardsMarketersRoute,HelpSlugRoute: HelpSlugRoute,NewsSlugRoute: NewsSlugRoute,PakistanSlugRoute: PakistanSlugRoute,ProductsBusinessSuccessRoute: ProductsBusinessSuccessRoute,SyriaSlugRoute: SyriaSlugRoute,TermsSplatRoute: TermsSplatRoute,TermsCookieRoute: TermsCookieRoute,LocaleIndexRoute: LocaleIndexRoute,ArIndexRoute: ArIndexRoute,TermsIndexRoute: TermsIndexRoute,PreviewArticlesIdRoute: PreviewArticlesIdRoute,PreviewLegalPagesIdRoute: PreviewLegalPagesIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)